import { map, Observable } from 'rxjs';
import { inject, Injectable } from '@angular/core';

/**
 * models
 */
import { IUnitTypeModel, UnitTypeModel } from '../models';

/**
 * services
 */
import { UnitTypeApiService } from './api';

/**
 * interfaces
 */
import {
    IUnitTypeDetailsDto,
    ICreateUnitTypePayload,
    IUpdateUnitTypePayload,
} from '../interfaces';

/**
 * Business / facade layer for Unit Types operations.
 */
@Injectable()
export class UnitTypeService {

    private readonly _api = inject(UnitTypeApiService);

    /** Returns all unit types as view models. */
    public getList(): Observable<IUnitTypeModel[]> {
        return this._api
            .getList()
            .pipe(
                map((r) => r.data),
                map((dtos) => dtos.map((dto) => new UnitTypeModel(dto))),
            );
    }

    /** Returns the full detail DTO for a single unit type. */
    public getById(id: string): Observable<IUnitTypeDetailsDto> {
        return this._api.getById(id).pipe(map((r) => r.data));
    }

    /** Creates a new unit type and returns the new ID. */
    public create(payload: ICreateUnitTypePayload): Observable<string> {
        return this._api.create(payload).pipe(map((r) => r.data));
    }

    /** Updates an existing unit type and returns the ID. */
    public update(id: string, payload: IUpdateUnitTypePayload): Observable<string> {
        return this._api.update(id, payload).pipe(map((r) => r.data));
    }

    /** Deletes a unit type by ID and returns the deleted ID. */
    public delete(id: string): Observable<string> {
        return this._api.delete(id).pipe(map((r) => r.data));
    }

}
